<template>
    <div>
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a class="nav-link" @click.prevent="setView('person-info')" :class="{ 'active': selectedView === 'person-info'}" href="#">Información</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" @click.prevent="setView('entry-history')" :class="{ 'active': selectedView === 'entry-history'}" href="#">Hisorial de ingresos</a>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    props: {
        changeView: {
            type: Function,
            required: true
        }
    },
    data(){
        return {
            selectedView: 'person-info'
        }
    },
    methods: {
        setView(view){
            this.selectedView = view;
            this.changeView(view);
        }
    }
}
</script>

